import { useQueryClient } from '@tanstack/react-query'
import { lcCoachingApi } from '@/api/lcCoaching'
import { coachingKeys } from './useCoachingToday'
import { invalidateReviewNoteSources } from './useReviewNote'

export function useRefreshLessonProgress(learnerId: number, lessonId?: number) {
  const qc = useQueryClient()

  return async () => {
    const targets = [
      {
        queryKey: coachingKeys.learnerToday(learnerId),
        queryFn: () => lcCoachingApi.getLearnerToday(learnerId),
      },
      {
        queryKey: coachingKeys.library(learnerId, 'all'),
        queryFn: () => lcCoachingApi.getLibrary(learnerId, 'all'),
      },
    ] as const

    await Promise.all([
      ...targets.map(({ queryKey }) => qc.invalidateQueries({ queryKey })),
      invalidateReviewNoteSources(qc, learnerId),
    ])
    await qc.invalidateQueries({ queryKey: coachingKeys.designatedReviews(learnerId) })
    await Promise.all([
      qc.fetchQuery({
        queryKey: coachingKeys.learnerToday(learnerId),
        queryFn: () => lcCoachingApi.getLearnerToday(learnerId),
      }),
      qc.fetchQuery({
        queryKey: coachingKeys.library(learnerId, 'all'),
        queryFn: () => lcCoachingApi.getLibrary(learnerId, 'all'),
      }),
      qc.fetchQuery({
        queryKey: coachingKeys.designatedReviews(learnerId),
        queryFn: () => lcCoachingApi.listDesignatedReviews(learnerId),
      }),
    ])

    if (lessonId == null) return

    await Promise.all([
      qc.invalidateQueries({ queryKey: coachingKeys.guide(learnerId, lessonId) }),
      qc.invalidateQueries({ queryKey: coachingKeys.workbookGrades(learnerId, lessonId) }),
    ])
    await Promise.all([
      qc.refetchQueries({ queryKey: coachingKeys.guide(learnerId, lessonId), type: 'all' }),
      qc.refetchQueries({ queryKey: coachingKeys.workbookGrades(learnerId, lessonId), type: 'all' }),
    ])
  }
}
